<template>
  <div v-loading="$wait.waiting(_uid)" class="card show-group">
    <div class="card-content">
      <acl
        :permissions="['companies_groups_update', 'companies_groups_destroy']"
      >
        <div class="text-right wrapper-button control-button-wrapper pt-xxs">
          <acl :permissions="['companies_groups_destroy']">
            <button
              type="button"
              class="btn btn-danger btn-wd submit-button"
              @click="handleDeleteGroup"
            >
              Delete
            </button>
          </acl>

          <button
            type="button"
            class="btn btn-cancel btn-primary btn-wd submit-button"
            @click="cancelShow"
          >
            Cancel
          </button>

          <acl :permissions="['companies_groups_update']">
            <button
              class="btn btn-info btn-fill btn-wd submit-button"
              @click.prevent="handleEditGroup"
            >
              Update
            </button>
          </acl>
        </div>
      </acl>

      <div class="row">
        <div class="col-xs-12">
          <h5 class="text-info">
            <b>Profile</b>
          </h5>
        </div>

        <div class="col-xs-12">
          <b>Name</b>
          <div class="mt-xs">
            <fg-input
              v-model="model.name"
              type="text"
              placeholder="Name"
              required
            />
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <div class="card-header pt-xxxs pb-xs">
              <b> Training Manager </b>
            </div>
            <div class="col-md-6 col-xs-12">
              <div class="form-group text-left">
                <ul class="list-unstyled">
                  <li v-for="manager in managers" :key="manager.fullName">
                    <div class="wrapper-switch mr-xs">
                      <p-switch
                        :value="model.managers.includes(manager.id)"
                        type="primary"
                        name="notification"
                        @input="toggleManager(manager.id)"
                      />
                      {{ manager.fullName }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xs-12">
          <hr />
          <h5 class="text-info">
            <b>Trainees</b>
          </h5>
          <div class="row">
            <TableTrainees
              :trainees="model.trainees"
              @remove="(data) => changeTrainee('remove', data)"
              @move="(data) => changeTrainee('move', data)"
            />
          </div>
        </div>

        <div class="col-xs-12 form-group text-left create-group">
          <hr />
          <div class="row mb-s pb-s">
            <div class="card-header pt-xxxs">
              <h5 class="title text-info">
                <b> Add trainees </b>
              </h5>
            </div>
            <div class="col-xs-12">
              <div class="form-group text-left">
                <div class="card-content">
                  <div class="mt-s">
                    <div class="mb-5 w-full">
                      <fieldset>
                        <div class="form-group">
                          <input
                            v-model="searchQuery"
                            type="search"
                            class="form-control form-search"
                            placeholder="Type to find what you are looking for"
                            aria-controls="datatables"
                            autofocus
                          />
                        </div>
                      </fieldset>
                    </div>

                    <div>
                      <el-table
                        ref="multipleTable"
                        :data="queriedData"
                        :default-sort="defaultSort"
                        border
                        stripe
                        style="width: 100%"
                        @selection-change="handleSelectionChange"
                        @row-click="clickRow"
                      >
                        <el-table-column
                          fixed
                          label="Add"
                          type="selection"
                          width="80"
                        />

                        <el-table-column
                          v-for="column in tableColumns"
                          :key="column.label"
                          sortable
                          :sort-orders="['ascending', 'descending']"
                          :min-width="column.minWidth"
                          :prop="column.prop"
                          :label="column.label"
                          :class-name="column.label"
                        />
                      </el-table>
                    </div>

                    <!-- <div class="flex justify-between items-center">
                      <div>
                        <p class="category">
                          Showing {{ from + 1 }} to {{ to }} of
                          {{ total }} entries
                        </p>
                      </div>

                      <p-pagination
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total"
                      />

                      <div>
                        <el-select
                          v-model="pagination.perPage"
                          class="select-default"
                          placeholder="Per page"
                        >
                          <el-option
                            v-for="item in pagination.perPageOptions"
                            :key="item"
                            class="select-default"
                            :label="item"
                            :value="item"
                          />
                        </el-select>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import PPagination from "@components/UIComponents/Pagination.vue";
import { Table, TableColumn } from "element-ui";
import _get from "lodash.get";
import _xor from "lodash.xor";
import _cloneDeep from "lodash.clonedeep";
import Vue from "vue";
import tableConfig from "@providers/table";
import joinByName from "@helpers/joinByName";
import PSwitch from "@components/UIComponents/Switch.vue";
import TableTrainees from "./components/GroupEdit/TableTrainees";
import { mapGetters, mapActions } from "vuex";
import swal from "sweetalert2";

Vue.use(Table);
Vue.use(TableColumn);
export default {
  components: {
    //PPagination,
    PSwitch,
    TableTrainees,
  },
  data() {
    const model = {
      name: "",
      managers: [],
      add: [],
      remove: [],
      move: {},
    };

    const table = {
      tableColumns: [
        {
          prop: "fullName",
          label: "Name",
          minWidth: 150,
        },
        // {
        //   prop: "rpe",
        //   label: "Registry, Purpose, Equipment",
        //   minWidth: 200
        // },
        // {
        //   prop: "roles",
        //   label: "Roles",
        //   minWidth: 200
        // }
      ],
    };

    return {
      model,
      ...table,
      ...tableConfig.data,
      defaultSort: { prop: "fullName", order: "ascending" },
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    ...mapGetters("companyGroupStore", ["group", "managers", "trainees"]),
    tableData() {
      return this.trainees.map((trainee) => ({
        ...trainee,
        rpe: joinByName(trainee.company.rpe),
        roles: joinByName(trainee.company.roles),
      }));
    },
    ...tableConfig.computed,
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
      const groupId = _get(this, "$route.params.id");
      await this.getManagersAndTrainees();
      await this.getCompanyGroupById(groupId);
      this.model = {
        ...this.model,
        ...this.parseGroup(_cloneDeep(this.group)),
      };
    } catch (error) {
      this.addNewError(error);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("companyGroupStore", [
      "getCompanyGroupById",
      "getManagersAndTrainees",
      "updateCompanyGroup",
      "deleteGroup",
    ]),
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
    parseGroup(group) {
      const managers = group.managers.map((manager) => {
        return manager.id;
      });

      return {
        id: group.id,
        name: group.name,
        managers: managers,
        trainees: group.trainees,
      };
    },
    toggleManager(manager) {
      this.model.managers = _xor(this.model.managers, [manager]);
    },
    changeTrainee(type, data) {
      this.model[type] = data;
    },
    async handleDeleteGroup() {
      try {
        this.$wait.start(this._uid);

        const shouldDelete = await swal({
          title: "Confirmation",
          text: "Do you really want to delete this group?",
          type: "warning",
          buttonsStyling: false,
          reverseButtons: true,
          confirmButtonClass: "btn ml-xs btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          showCancelButton: true,
        });

        if (!shouldDelete) {
          return;
        }

        await this.deleteGroup(this.group.id);

        this.$notify({
          message: "Group deleted successfully!",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success",
        });

        this.$router.push({ name: "companies_groups@index" });
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
    async handleEditGroup() {
      try {
        this.$wait.start(this._uid);

        this.model.add = this.model.add.map((trainee) => {
          return trainee.id;
        });

        await this.updateCompanyGroup({
          groupId: this.group.id,
          data: {
            name: this.model.name,
            managers: this.model.managers,
            add: this.model.add,
            remove: this.model.remove,
            move: this.model.move,
          },
        });

        this.$notify({
          message: "Group updated successfully",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success",
        });

        return this.cancelShow();
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
    handleSelectionChange(val) {
      this.model.add = val;
    },
    // click on the entire row to select
    clickRow(row) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    cancelShow() {
      return this.$router.push({
        name: "companies_groups@show",
        params: { id: this.group.id },
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/paper/variables";
@import "@/assets/sass/tables";
.btn-cancel {
  margin: 0 12px;
}
.create-group {
  td.Name {
    position: relative;
    z-index: 1;

    .cell {
      color: $info-color;
      font-weight: 600;
      cursor: pointer;
      display: inline;
    }
  }
}

@media (max-width: 1024px) {
  .wrapper-button .btn {
    width: 100%;
  }
  .btn-cancel {
    margin: 12px 0;
  }
}
</style>
